import { render, staticRenderFns } from "./PoliticasCalidad.vue?vue&type=template&id=8ec5f4ca"
import script from "./PoliticasCalidad.vue?vue&type=script&lang=js"
export * from "./PoliticasCalidad.vue?vue&type=script&lang=js"
import style0 from "./PoliticasCalidad.vue?vue&type=style&index=0&id=8ec5f4ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports